const icons = {
  success:'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="#039855" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 6 9 17l-5-5"/></svg>',
  delete: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" fill="none"><path stroke="#D92D20" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5.54v-.8c0-1.121 0-1.681-.218-2.109a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 3.06 6 3.62 6 4.74v.8m2 5.5v5m4-5v5M1 5.54h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 19.259 3 18.419 3 16.739V5.54"/></svg>',
  alert: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" fill="none"><path stroke="#DC6803" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 7.77v4m0 4h.01m9.99-4c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10s10 4.477 10 10Z"/></svg>',
  error: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" fill="none"><path stroke="#D92D20" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 7.77v4m0 4h.01m9.99-4c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10s10 4.477 10 10Z"/></svg>',
  confirm: '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" fill="none"><path stroke="#1570EF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 11.5V5.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 1 13.88 1 12.2 1H5.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C1 3.28 1 4.12 1 5.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C3.28 21 4.12 21 5.8 21H9m2.5-3 2 2 4.5-4.5"/></svg>'
}

const iconContainerBg = {
  success: 'tw-bg-ugreen-100',
  delete: 'tw-bg-ured-100',
  alert: 'tw-bg-uorange-100',
  confirm: 'tw-bg-ublue-100',
  error: 'tw-bg-uorange-100',
}

export function alertModal({ title, text, type }) {
  if (!type) {
    type = 'delete'
  }

  return `
  <div class="tw-flex tw-flex-col tw-gap-5 tw-rounded-xl font--base">
    <header class="tw-flex tw-justify-start">
      <div class="tw-flex ${iconContainerBg[type]} tw-justify-center tw-items-center tw-rounded-full tw-h-12 tw-w-12">
        ${icons[type]}
      </div>
    </header>
    <div class="tw-flex tw-flex-col tw-gap-2 tw-text-left">
    <h2 class="tw-text-ugray-900 tw-leading-7 tw-font-medium tw-text-lg">${title}</h2>
    <p class="tw-text-ugray-700 tw-text-sm tw-leading-5">${text}</p>
    </div>
  </div>
`
}
